import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./slice";

const selectDomain = (state: any) => state.paymentState || initialState;

export const paymentSelector = createSelector(selectDomain, (state) => state);

export const paymentHistoryListSelector = createSelector(
  selectDomain,
  (state) => state.paymentHistoryList
);

export const paymentLogsListSelector = createSelector(
  selectDomain,
  (state) => state.paymentLogsList
);

export const purchaseSeatLogsListSelector = createSelector(
  selectDomain,
  (state) => state.purchaseSeatLogsList
);

export const paymentLogsPaginationParamsSelector = createSelector(
  selectDomain,
  (state) => state.paymentLogspaginationParams
);

export const purchaseSeatLogspaginationParamsSelector = createSelector(
  selectDomain,
  (state) => state.purchaseSeatLogspaginationParams
);

export const activeSubscriptionSelector = createSelector(
  selectDomain,
  (state) => state.activeSubscriptionData
);

export const isLoadingSelector = createSelector(
  selectDomain,
  (state) => state.isLoading
);

export const isButtonLoadingSelector = createSelector(
  selectDomain,
  (state) => state.isButtonLoading
);

export const paymentDetailsSelector = createSelector(
  selectDomain,
  (state) => state.paymentDetails
);

export const subscriptionSkipLimitSelector = createSelector(
  selectDomain,
  (state) => state.subscriptionSkipLimit
);

export const paymentMethodsListSelector = createSelector(
  selectDomain,
  (state) => state.paymentMethods
);

export const userCardDetailsSelector = createSelector(
  selectDomain,
  (state) => state.userCardDetails
);

export const paymentResponseSelector = createSelector(
  selectDomain,
  (state) => state.paymentResponse
);
